import { PageDataHandler } from "@/lib/utility/data/page-data-handler";
import { ITag, Tag } from "@/models/tag.entity";
import { MrfiktivTagControllerFindAllByPartnerIdParamsGen } from "@/services/mrfiktiv/v1/data-contracts";
import store from "@/store/VuexPlugin";
import { Action, getModule, Module } from "vuex-module-decorators";
import { PaginatedBaseStore } from "../paginated-base.store";
import { TagDataAccessLayer } from "./access-layers/tag.access-layer";
import { PaginationFilterListElement } from "./base-pagination.store";
import { TagPageDataProvider } from "./page-data-provider/tag.page-data-provider";
import { ActionEnum } from "../enum/authActionEnum";
import { ResourceEnum } from "../enum/authResourceEnum";
import { UserModule } from "./me-user.store";
import { PartnerModule } from "./partner";
import { log } from "@/lib/utility/log";

@Module({
  dynamic: true,
  namespaced: true,
  name: "tag",
  store
})
class TagStore extends PaginatedBaseStore<ITag, MrfiktivTagControllerFindAllByPartnerIdParamsGen> {
  protected _data = TagDataAccessLayer;
  protected _pageProvider = TagPageDataProvider;
  protected _pager = new PageDataHandler(this._data, this._pageProvider);

  filterOptions: PaginationFilterListElement[] = Tag.filterables;

  @Action
  async reset(): Promise<void> {
    super.reset();
    if (!UserModule.abilities.can(ActionEnum.READ, ResourceEnum.TAG, PartnerModule.partner.id)) {
      return;
    }
    this.setFilters([]);
    await this.fetchFirstPage({ partnerId: PartnerModule.partner.id }).catch(e => log.error(e));
  }
}

export const TagModule = getModule(TagStore);
